import { generatePath, Navigate, Route } from "react-router";
import React from "react";
import { ModalLoadingSpinner } from "../modal-loading-spinner";
import {
  GUIDED_SELLING_PATH,
  GUIDED_SELLING_PATH_ROOT,
  LazyGuidedSellingPreview,
} from "../guided-selling-preview/LazyGuidedSellingComponent";
import { EditorsAppLayoutShell } from "../../EditorsAppLayoutShell";
import { Global } from "@emotion/react";
import { getGlobalFontStyles } from "../../styles/styles-global";
import { AppView } from "../../styles/AppView";

export const GuidedSellingPreviewRouterRoutes = [
  <Route
    key={"1"}
    // exact={true}
    path={GUIDED_SELLING_PATH_ROOT}
    element={<Navigate to={generatePath(GUIDED_SELLING_PATH, { screenIdx: "0" })} />}
  />,
  <Route
    key={"2"}
    path={GUIDED_SELLING_PATH}
    element={
      <AppView>
        <EditorsAppLayoutShell headline={"Preview - Guided Selling"}>
          <Global styles={getGlobalFontStyles("en")} />
          <React.Suspense fallback={<ModalLoadingSpinner />}>
            <LazyGuidedSellingPreview />
          </React.Suspense>
        </EditorsAppLayoutShell>
      </AppView>
    }
  />,
];
